// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width:480px){.star-rating[data-v-18851088]{justify-content:flex-end;width:46%}}.star-rating[data-v-18851088]{display:flex}", ""]);
// Exports
module.exports = exports;
